import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, Users, ShieldCheck, Lock, CreditCard, Star, Layers, Gift, CheckCircle2 } from 'lucide-react';
const featured = [{
  icon: FileText,
  text: '100% PDF'
}, {
  icon: Zap,
  text: 'Acceso inmediato'
}, {
  icon: BookOpen,
  text: 'Sílabas → Palabras → Frases → Cuentos'
}, {
  icon: Users,
  text: 'Para Padres'
}];
export function TrustBar() {
  return <section className="bg-white pb-10 pt-2 overflow-hidden" data-id="element-325">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-326">
        {/* Featured badges — elevated white cards in a centered tapering cluster */}
        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-327">
          {featured.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex items-center gap-2.5 bg-white rounded-2xl px-5 py-3.5 shadow-lg shadow-slate-200/60 border border-slate-100" data-id="element-328">
              <item.icon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-329" />
              <span className="text-sm md:text-base font-semibold text-navy whitespace-nowrap" data-id="element-330">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}